import styled from "styled-components";
import {DialogTextBox, dialogHighlightedTextMixin} from "../../../modal-dialog/boxes/text/dialog-text.box";

export const TsrWithDropdownMainTextDefaultBox = styled(DialogTextBox)`
    display: flex;

    > span:nth-of-type(2) {
       ${dialogHighlightedTextMixin}
       margin-left: 5px;
    }

    @media ${({theme}) => `${theme.mediaQuery.lAndBelow} and ${theme.mediaQuery.portrait}`} {
        flex-direction: column;

        > span:nth-of-type(2) {
            margin: 1rem 0 0 0;
        }
    }
`;
